import { Student, User, TuitionFeeReport } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    studentSearchParams: {},
    students: [],
    pageText: '',
    totalItems: 0,
    itemsPerPage: 5,
  },
  actions: {
    async searchStudents({ commit, state, dispatch }, query) {
      const studentSearchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { studentSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, periodId }) {
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.studentSearchParams) {
        let studentSearchParams = {
          ...state.studentSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'nameToNumber:ASC,index:ASC',
        }
        const [totalItems, students] = await Promise.all([
          Student.qsCount(studentSearchParams),
          Student.qsFetch(studentSearchParams),
        ])
        if (periodId) {
          let promises = students.map(async student => {
            return TuitionFeeReport.search({ student: student.id, period: periodId })
          })
          let periods = await Promise.all(promises)
          students.map(student => {
            let period = periods.find(period => {
              if (period.length > 0) return period[0].student.id === student.id
            })
            if (period) {
              student.moneyTotal = period[0].totalSumFee - period[0].totalMinusFee
              student.idStudentPeriod = period[0]._id
              student.notePeriod = period[0].notes
            }
            return student
          })
        }
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            students,
            totalItems,
            itemsPerPage,
            studentSearchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
    },
    async getOneStudent({ commit }, params) {
      const { id, ...options } = params
      const student = await Student.fetchOne(id, options)
      commit('updateStudent', student)
      return student
    },
    async getManyStudents({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setStudents', [])
      }
      const students = await Student.qsFetch(searchParams)
      if (!disableSave) {
        commit('setStudents', students)
      }
      return students
    },
    async getAllStudents({ commit }, { searchParams, disableSave = false }) {
      if (!disableSave) {
        commit('setStudents', [])
      }
      const students = await Student.fetch({ ...searchParams, _limit: -1, _start: 0 })
      if (!disableSave) {
        commit('setStudents', students)
      }
      return students
    },
    async getStudentCount(_, params) {
      const studentCount = await Student.qsCount(params)
      return studentCount
    },
    async createStudent({ commit }, userData) {
      const newStudent = await Student.create({
        ...userData,
      })
      // commit('addStudent', newStudent)
      commit('setStudents', [newStudent])
      return newStudent
    },
    async updateStudent({ commit }, { id, ...updateStudentData }) {
      await Student.update(id, updateStudentData)
    },
    async updateStudents({ dispatch }, items) {
      await Promise.all(items.map(item => dispatch('updateStudent', item)))
    },
    async removeStudent({ commit }, student) {
      const promises = []
      promises.push(User.remove(student.user))
      promises.push(Student.remove(student.id))
      await Promise.all(promises)
      commit('removeStudent', student)
    },
    async removeStudents({ dispatch }, students) {
      await Promise.all(students.map(student => dispatch('removeStudent', student)))
    },
    async changeStudentClass(_, params) {
      await Student.changeStudentClass(params)
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setStudents(state, students) {
      state.students = students
    },
    addStudent(state, student) {
      state.students.push(student)
    },
    updateStudent(state, student) {
      state.students = state.students.map(s => {
        if (s.id === student.id) {
          return { ...s, ...student }
        }
        return s
      })
    },
    removeStudent(state, student) {
      state.students = state.students.filter(s => {
        return s.id !== student.id
      })
    },
  },
}
